import IdleStage from './IdleStage'

export default IdleStage
